export interface ApiExportTranslationRequest {
    original: string;
    title: string;
    translation: string;
}

export const ExportTranslation = Symbol('ExportTranslation');

export interface ExportTranslation {
    exportTranslation(data: ApiExportTranslationRequest): Promise<string>;
}